import { getXcoreConfig, only } from "@robe/core";
import { GetServerSidePropsContext, GetStaticPropsContext } from "next";
import { ContextWithXcore } from "./types";

/**
 * Creates a ctx object which is available in `getXcoreProps` or `getXcoreServerProps` functions
 */
export const createXcoreContext = async <T extends GetStaticPropsContext | GetServerSidePropsContext>(
  ctx: T
): Promise<ContextWithXcore<T>> => {
  const config = await getXcoreConfig();
  /** User in not available in `getStaticProps` so auth token is passed from `previewData` */
  const isPreview = ctx.preview && ctx.previewData && typeof ctx.previewData === "object" && "authToken" in ctx.previewData;
  const core = config.getCoreInstance(
    ctx.locale!,
    isPreview
      ? {
        authToken: (ctx.previewData as any).authToken,
      }
      : {}
  );

  const query = {
    ...ctx.params,
    ...("query" in ctx ? ctx?.query : {}),
  };

  const idParsed = only(query.id);
  const slugParsed = only(query.slug);

  return {
    ...(ctx as Omit<T, "locales">),
    core,
    ...(typeof slugParsed === "string" && slugParsed !== "" && { slug: slugParsed }),
    ...(typeof idParsed === "number" ? { id: +idParsed } : typeof idParsed === "string" && { id: +idParsed }),
  };
};
